// SHA-256 of the exact bytes the client is about to upload. Sent with the
// upload-URL request so the worker can reject re-uploads before a row or any
// storage object is created (FIX 1 — permanent dedup engine). Uses Web Crypto,
// available in every browser the editor supports.

export async function sha256Hex(
  data: ArrayBuffer | ArrayBufferView | Blob,
): Promise<string> {
  let buf: ArrayBuffer;
  if (data instanceof Blob) {
    // Blob.arrayBuffer() in every supported browser; Response fallback keeps
    // the helper usable in older test runtimes that lack it.
    buf =
      typeof data.arrayBuffer === 'function'
        ? await data.arrayBuffer()
        : await new Response(data).arrayBuffer();
  } else if (ArrayBuffer.isView(data)) {
    buf = data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength) as ArrayBuffer;
  } else {
    buf = data;
  }
  const digest = await crypto.subtle.digest('SHA-256', buf);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}
